module.exports = __webpack_public_path__ + "static/img/portfolio2.62eb296.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/portfolio2.jpg
// module id = sSEA
// module chunks = 0